import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { CopyButton } from '@/components/copy-button';
import { UrlItem } from './url-list-item';

// 浏览器环境检测
const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
  require('codemirror/mode/markdown/markdown.js');
  require('codemirror/lib/codemirror.css');
  require('codemirror/keymap/sublime.js');
  require('codemirror/theme/solarized.css');
}

interface MarkdownPreviewProps {
  selectedItem: UrlItem | null;
}

export const MarkdownPreview: React.FC<MarkdownPreviewProps> = ({ selectedItem }) => {
  const editorOptions = {
    mode: 'markdown',
    theme: 'solarized light',
    tabSize: 2,
    keyMap: 'sublime',
    readOnly: true,
    viewportMargin: Infinity,
    lineWrapping: true
  };

  return (
    <div className="lg:col-span-2 border border-orange-400 rounded overflow-hidden shadow">
      <div className="bg-orange-100 px-4 py-3 border-b border-orange-400 flex justify-between items-center">
        <h2 className="font-bold">
          {selectedItem ? (selectedItem.title || selectedItem.url) : '预览 Markdown'}
        </h2>
        {selectedItem && selectedItem.markdown && (
          <CopyButton 
            value={selectedItem.markdown} 
            variant="ghost"
            size="sm"
          />
        )}
      </div>
      <div className="h-[calc(100vh-24rem)] overflow-y-auto">
        {!selectedItem ? (
          <div className="text-gray-500 text-center py-20">
            请选择 URL 查看 Markdown 内容
          </div>
        ) : selectedItem.loading ? (
          <div className="text-blue-500 text-center py-20">
            解析中，请稍候...
          </div>
        ) : selectedItem.error ? (
          <div className="text-red-500 text-center py-20">
            {selectedItem.error}
          </div>
        ) : !selectedItem.markdown ? (
          <div className="text-gray-500 text-center py-20">
            尚未解析，请点击"开始解析"按钮
          </div>
        ) : (
          isBrowser && (
            <CodeMirror
              value={selectedItem.markdown}
              options={editorOptions}
              onBeforeChange={() => {}}
              className="h-full"
            />
          )
        )}
      </div>
    </div>
  );
}; 